var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPro = function SvgIconPro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6 13.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.125 9a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.136 5.274a5.625 5.625 0 1 1 7.59 7.59q.024.315.024.636a8.25 8.25 0 1 1-7.614-8.226m4.989-1.524a4.13 4.13 0 0 0-3.836 2.605l-.219.552-.587-.086a6.75 6.75 0 1 0 5.696 5.696l-.086-.587.552-.219a4.127 4.127 0 0 0-1.52-7.961",
    clipRule: "evenodd"
  })));
};
export default SvgIconPro;